export default {
  'pointHistory.title': 'ประวัติการใช้แต้ม',
  'pointHistory.event.deduct': 'หักแต้ม',
  'pointHistory.event.collect': 'สะสมแต้ม',
  'pointHistory.event.transfer': 'โอนแต้ม',
  'pointHistory.event.0': 'ไม่เข้าเงื่อนไขการให้แต้ม',
  'pointHistory.event.1': 'ให้แต้มเมื่อครบยอดที่กำหนด',
  'pointHistory.event.4': 'ให้แต้มแบบยืดหยุ่น',
  'pointHistory.event.10': 'หักแต้มแบบยืดหยุ่น',
  'pointHistory.event.20': 'หักแต้มจากการแปลงเป็นคูปองอัตโนมัติ',
  'pointHistory.event.21': 'หักแต้มจากการเลือกคูปองอิสระ',
  'pointHistory.event.22': 'แต้มหมดอายุ',
  'pointHistory.event.90': 'ยกเลิกการสะสมแต้ม',
  'pointHistory.event.91': 'ยกเลิกรายการและหักแต้ม',
  'pointHistory.event.92': 'ยกเลิกรายการ - คืนแต้มจากการแปลงคูปองอัตโนมัติ',
  'pointHistory.event.93': 'ยกเลิกการให้แต้ม',
  'pointHistory.event.94': 'ยกเลิกการหักแต้ม',
  'pointHistory.message.cancel_success': 'ยกเลิกรายการสะสมแต้มสำเร็จแล้ว',
  'pointHistory.message.cancel_fail': 'ไม่สามารถยกเลิกรายการสะสมแต้ม',
  'pointHistory.current_points': 'แต้มคงเหลือ',
  'pointHistory.expiration_date': 'วันที่หมดอายุของแต้ม',
  'pointHistory.button.cancel': 'ยกเลิกรายการ',
  'pointHistory.empty': 'ไม่มีข้อมูล',
  'pointHistory.point_detail': 'รายละเอียดแต้ม',
  'pointHistory.processing_time': 'เวลาการดำเนินการ',
  'pointHistory.remark': 'หมายเหตุ',
  'pointHistory.consumption_amount': 'จำนวนการใช้จ่าย',
  'pointHistory.bottomDateRange.dateFrom': 'เริ่มต้น',
  'pointHistory.bottomDateRange.dateTo': 'สิ้นสุด',
  'pointHistory.bottomDateRange.error.dateFrom': 'โปรดเลือกวันที่เริ่มต้น',
  'pointHistory.bottomDateRange.error.dateTo': 'โปรดเลือกวันที่สิ้นสุด',
  'pointHistory.bottomDateRange.error.dateRange': 'วันที่เริ่มต้นไม่สามารถเป็นหลังจากวันที่สิ้นสุด',
  'pointHistory.bottomDateRange.search': 'ค้นหา',
  'pointHistory.bottomDateRange.cancel': 'ยกเลิก',
} as Record<string, string>;
